import { inferRouterOutputs } from "@trpc/server";

import { AppRouterType } from "@/common/helpers/trpc";

export type CommandFromQuery = NonNullable<inferRouterOutputs<AppRouterType>["retrieveDonorCommand"]>;
export type PaymentFromQuery = NonNullable<inferRouterOutputs<AppRouterType>["retrieveDonorDashboardTransaction"]>;
export type SubscriptionFromQuery = inferRouterOutputs<AppRouterType>["retrieveDonorDashboardSubscription"]["object"];
export type ReceiptFromQuery = NonNullable<inferRouterOutputs<AppRouterType>["retrieveDonorReceipt"]>;

export const DONOR_PAYMENT_CONTROLS = [
  "cancel_renewal",
  "update_payment_method",
  "edit_charge_date",
  "change_amount",
  "adjust_tip",
] as const;
export type DonorPaymentControl = (typeof DONOR_PAYMENT_CONTROLS)[number];
